import './style';
import { SaleBadgeProps } from '../../types';
import { StyledSpaceGoSaleBadge } from './style';
import { generateSalePercentageBasedOnType } from '../../../../utils';
import { ESalePercentageDisplayType } from '../../../Helper/enums';

const LocoBingoSaleBadge = ({
    salePercentage,
    salePercentageDisplayType
}: SaleBadgeProps) => {
    const backgroundImage =
        'url(https://media.appcharge.com/defaults/spaceGo_badge.png)';

    return (
        <StyledSpaceGoSaleBadge backgroundImage={backgroundImage}>
            <div className="amount">
                {generateSalePercentageBasedOnType(
                    salePercentage,
                    salePercentageDisplayType
                )}
            </div>
        </StyledSpaceGoSaleBadge>
    );
};

export default LocoBingoSaleBadge;
